import { z } from 'zod';

export interface BrandDetails {
  id: string;
  name: string;
}

export interface ModelDetails {
  id: string;
  name: string;
}

export interface TypeDetails {
  id: string;
  name: string;
}

export interface UserData {
  id: string;
  fullName: string;
  email: string;
}

export interface AssetData {
  id: string;
  brand: {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
  };
  model: {
    id: string;
    name: string;
    brandId: string;
    createdAt: string;
    updatedAt: string;
    brand_id: string;
  };
  serialNumber: string;
  purchaseDate: string;
  warrantyDate: string | null;
  status: string;
  condition: string;
  officeId: string | null;
  userId: string;
  user?: UserData;
  accesory: string;
  note: string;
  brandDetails: BrandDetails;
  modelDetails: ModelDetails;
  typeDetails: TypeDetails;
}

export interface AssignmentApi {
  id: string;
  assetId: string;
  userId: string;
  assignedAt: string;
  returnedAt: string;
  createdAt: string;
  updatedAt: string;
  asset: AssetData;
  user: UserData;
}

export interface AssignmentsFilter {
  assetId?: string;
  userId?: string;
}

export const createAssignmentsSchema = z.object({
  assetId: z.string().min(1, 'Debe seleccionar un activo'),
  userId: z.string().min(1, 'Debe seleccionar un usuario'),
  returnedAt: z.date().nullable().optional(),
});

export type CreateAssignmentsSchema = z.infer<typeof createAssignmentsSchema>;

export const defaultValues: CreateAssignmentsSchema = {
  assetId: '',
  userId: '',
  returnedAt: null,
};
